import { Mail, MapPin, Phone } from 'lucide-react';
import React from 'react';

function ContactInfo() {

   return (
  <section className="w-full bg-light-5 py-12 md:py-16 lg:py-24 px-6">
    <div className="max-w-4xl mx-auto grid gap-6 md:grid-cols-3 text-center">
      <div>
        <Mail className="mx-auto text-blue-1 mb-2" />
        <p className="font-semibold text-dark-1">Email</p>
        <p className="text-light-1">contact@gonextmaker.org</p>
      </div>
      <div>
        <Phone className="mx-auto text-blue-1 mb-2" />
        <p className="font-semibold text-dark-1">Téléphone</p>
        <p className="text-light-1">+229 XX XX XX XX</p>
      </div>
      <div>
        <MapPin className="mx-auto text-blue-1 mb-2" />
        <p className="font-semibold text-dark-1">Adresse</p>
        <p className="text-light-1">[Adresse du fablab ou siège]</p>
      </div>
    </div>
  </section>
)};

export default ContactInfo;